import request from '@/plugin/axios';

// 拉取省、市、区、学校
export function getAreaById(parentId) {
  return request({
    url: '/baseApi/area/getAreaById',
    method: 'get',
    params: {
      parentId
    }
  });
}
// 获取Iot服务
export function getIotList() {
  return request({
    url: '/baseApi/school/getIotList',
    method: 'get'
  });
}
// 开通学校
export function grantSchool(schoolForm, schoolInfo) {
  const params = {
    third_party_id: schoolInfo[0],
    name: schoolInfo[1],
    code: schoolInfo[2],
    studentCount: 99999,
    iotUUid: schoolForm.plant,
    data_source: 'hitecloud',
    application: 'PCClient',
    license: '1',
    terminalIds: schoolForm.terminalIds
  };
  return request({
    url: '/baseApi/school/grantSchool',
    method: 'post',
    data: params
  });
}
// 删除学校
export function deleteSchool(data) {
  const params = {
    third_party_id: data
    // dynamicFlag: data
  };
  return request({
    url: '/baseApi/school/deleteSchool',
    method: 'post',
    data: params
  });
}
// 修改学校
export function editSchool(data) {
  const params = {
    third_party_id: data.schoolId,
    name: data.school,
    // studentCount: data.studentCount,
    iotUUid: data.plant,
    data_source: 'hitecloud',
    application: 'PCClient',
    dynamicFlag: data.schoolId
  };
  return request({
    url: '/baseApi/school/grantSchool',
    method: 'post',
    data: params
  });
}
// 学校数据同步
export function syncData(data) {
  const params = {
    schoolId: data.schoolId,
    dataSource: 'hitecloud',
    application: 'PCClient',
    dynamicFlag: data.schoolId
  };
  return request({
    url: '/baseApi/school/syncDataByTeacherId',
    method: 'post',
    data: params
  });
}
// 学校授权
export function schoolLicense(schoolId) {
  const params = {
    third_party_id: schoolId
  };
  return request({
    url: '/baseApi/school/licenseSchool',
    method: 'post',
    data: params
  });
}
// 添加作息策略
export function addSchedules(params) {
  return request({
    url: '/baseApi/schedules/addSchedules',
    method: 'post',
    data: params
  });
}
// 获取作息策略
export function getSchedulesByClassId(params) {
  return request({
    url: '/baseApi/schedules/getSchedulesByClassId',
    method: 'post',
    data: params
  });
}
// 获取时间
export function getSchoolTimeInfo(params) {
  return request({
    url: '/baseApi/school/getSchoolTimeInfo',
    method: 'post',
    data: params
  });
}
// 获取年级及班级
export function getSchoolInfoById(params) {
  return request({
    url: '/baseApi/school/getSchoolInfoById',
    method: 'post',
    data: params
  });
}

// 数据同步
export function syncDataByTeacher(date) {
  const params = {
    dataSource: 'hitecloud',
    application: 'PCClient',
    teacherId: date.teacherId,
    dynamicFlag: date.schoolId,
    schoolId: date.teacherId !== '' ? '' : date.schoolId,
    userType: '1',
    status: '1'
  };
  return request({
    url: '/baseApi/school/syncDataByTeacherId',
    method: 'post',
    data: params
  });
}

// 获取考勤类型列表
export function getAttendTypeList(param) {
  return request({
    url: '/attendanceApi/attendance/getAttendTypeList',
    method: 'post',
    data: {
      schoolId: param
    }
  });
}

// 修改考勤类型
export function updateSchoolAttendType(data) {
  return request({
    url: '/attendanceApi/attendance/updateSchoolAttendType',
    method: 'post',
    data
  });
}

// 导出列表
export function exportExcel(data) {
  return request({
    url: '/baseApi/studentExtend/exportExcel',
    method: 'get',
    params: {
      schoolId: data
    }
  });
}

// 导出列表
export function downloadTemplate(data) {
  return request({
    url: '/baseApi/studentExtend/exportExcel',
    method: 'get',
    params: {
      schoolId: data
    }
  });
}

// 获取权限列表
export function featchTerminalList() {
  return request({
    url: '/baseApi/terminal/getTerminalList',
    method: 'get'
  });
}

export function changeTerminal(data) {
  return request({
    url: '/baseApi/terminal/addTerminalToSchool',
    method: 'post',
    data
  });
}
